import * as React from 'react';
import { useTranslation } from "react-i18next";

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

import { Title } from '../../../components/Title';

import Image from '../../../images/home/IMG_1088.JPG';
import Image_de from '../../../images/home/Startseite_neu_DE.png';
import Image_it from '../../../images/home/Startseite_neu IT.png';


export default function Werwirsind() {

  const { t, i18n } = useTranslation();

  return (

    <div >

      <Grid container spacing={0} className='unsdien'>

        <Grid item xs={12} lg={6} id="team">

          <img src={Image} className='beratungen-im' alt="IMG_1088" width='100%' />

        </Grid>

        <Grid item xs={12} lg={6} sx={{ padding: 5 }} className='unser-textbox'>

          <Title title="who_are_we" variant="wtitle"></Title>

          <Box sx={{ paddingBottom: 0 }} />

          {t('who_are_we_1')}
          <Box sx={{ paddingBottom: 2 }} />

          {t('who_are_we_2')}
          <Box sx={{ paddingBottom: 2 }} />

          <Box
            sx={{
              fontSize: '18px'
            }} >
            {t('who_are_we_3')}
            Marco Lovatel, Sara Nicli, Kathrin Plunger, Helga Salchegger, Jutta Pfitscher, Dietmar Battisti
          </Box>

        </Grid>

      </Grid>


    </div>





  );
}